import api from '@/api/axios/main.api'

export const fetchPengumuman = (params) => {
  return api.get('/api/informasi', {params})
}

export const fetchPengumumanById = (id) => {
  return api.get(`/api/informasi/${id}`)
}

export const fetchAllTopic = () => {
  return api.get('/api/topic/all-admin')
}
